// libs
import React from 'react'

// components
import Icon from 'src/components/forms/icon/icon'
import Modal from 'src/components/modal/modal'

// constants
import { CLASS_PREFIX } from 'src/constants'

// styles
import { textResources } from 'src/lang/de'
import { COLOR_TYPE_WHITE } from 'src/utils/color'
import '../project_modal.scss'

type Props = {
  onClose: () => void;
};

const cls = `${CLASS_PREFIX}project-modal`
const t = textResources.projects

export const ProjectCreateMeetingSuccessModal: React.FC<Props> = ({ onClose }) => {
  return (
    <Modal autoSize onClose={onClose}>
      <div className={`${cls}__body`}>
        <div className={`${cls}__check`}>
          <Icon name="check" size={22} color={COLOR_TYPE_WHITE} />
        </div>
        <h3 className={`${cls}__title`}>{t.details.meetingCreated.title}</h3>
        <p className={`${cls}__text`}>{t.details.meetingCreated.text}</p>
      </div>
    </Modal>
  )
}
